import { DEMO_TENANT_ID } from "../../auth/auth.constants";
import { SubscriptionStatus } from "../models";
import type { Subscription } from "../models";
import type { SubscriptionUsage } from "../types";
import {
  PLAN_BUSINESS_ID,
  PLAN_ENTERPRISE_ID,
  getPlanTemplateById,
} from "./plans.seed";

const now = () => new Date().toISOString();

const trialEnd = new Date();
trialEnd.setDate(trialEnd.getDate() + 14);

export const SUBSCRIPTION_DEMO_ID = "sub-tenant-demo-001";

const businessTemplate = getPlanTemplateById(PLAN_BUSINESS_ID)!;
const enterpriseTemplate = getPlanTemplateById(PLAN_ENTERPRISE_ID)!;

export const SEED_SUBSCRIPTIONS: Subscription[] = [
  {
    id: SUBSCRIPTION_DEMO_ID,
    tenantId: DEMO_TENANT_ID,
    planId: PLAN_ENTERPRISE_ID,
    status: SubscriptionStatus.TRIAL,
    startDate: now(),
    trialEndsAt: trialEnd.toISOString(),
    quotas: { ...enterpriseTemplate.defaultQuotas },
    features: [...enterpriseTemplate.defaultFeatures],
    billingCycle: "monthly" as const,
    createdAt: now(),
    updatedAt: now(),
  },
  {
    id: "sub-acme-001",
    tenantId: "tenant-acme",
    planId: PLAN_ENTERPRISE_ID,
    status: SubscriptionStatus.ACTIVE,
    startDate: now(),
    quotas: { ...enterpriseTemplate.defaultQuotas },
    features: [...enterpriseTemplate.defaultFeatures],
    billingCycle: "yearly" as const,
    createdAt: now(),
    updatedAt: now(),
  },
  {
    id: "sub-platform-001",
    tenantId: "tenant-platform",
    planId: PLAN_ENTERPRISE_ID,
    status: SubscriptionStatus.ACTIVE,
    startDate: now(),
    quotas: { ...enterpriseTemplate.defaultQuotas },
    features: [...enterpriseTemplate.defaultFeatures],
    billingCycle: "yearly" as const,
    createdAt: now(),
    updatedAt: now(),
  },
];

export const SEED_USAGE: Record<string, SubscriptionUsage> = {
  [DEMO_TENANT_ID]: {
    users: 4,
    employees: 28,
    storageGb: 18,
    apiCallsThisMonth: 842,
  },
  "tenant-acme": {
    users: 87,
    employees: 420,
    storageGb: 245,
    apiCallsThisMonth: 12500,
  },
  "tenant-platform": {
    users: 5,
    employees: 12,
    storageGb: 8,
    apiCallsThisMonth: 3200,
  },
};

export { SEED_SUBSCRIPTIONS as default };
